import http from '@/utils/http';
import { IDENTITY_KEY_NAME } from '@/constants';
import { getIdentity } from '@/utils/detectDevice';

const post = async params => http.apiGet(`/addBooksTrack?uid=${await getIdentity(IDENTITY_KEY_NAME.UID)}`, params);

export default {
  post,
};
